import { css } from 'styled-components';

export const centerContentCSS = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;
